import BannerBackgroundPresentation from 'components/BannerBackground/BannerBackgroundPresentation'

export default BannerBackgroundPresentation
